import React from 'react';

// Components
import Range from "./Range";
import Datepicker from "../components/Datepicker";
import FormEmail from '../components/FormEmail';
import Rotate360 from './Rotate360';
import SearchService from '../classes/SearchService';
import PDFGenerator from './PDFGenerator';
import Colors from './Colors';

import getExternalLink from '../functions/getExternalLink';

import { connect } from 'react-redux';

import { identify, setPageParams } from '../redux/actions/UserActions';
import { setBike, setUnitDatabase, setUnit, setColorDatabase, setLinkDatabase } from '../redux/actions/BikeActions';

// database
import '../firebase/firebase'

const searchService = new SearchService();

class App extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            open: false,
            copied: false
        };
    }

    // Copy embed code to buffer
    copyClipboard = () => {
        this.setState(() => {
            return { copied: true }
        })
    }

    componentWillMount() {
        // set default bike data to store fo rendering options
        const bike = searchService.defaultBike();

        this.props.dispatch(setBike({ bike }));
        this.props.dispatch(setUnit({ unit: 'inches' }))

    };

    componentDidMount() {

        // create new User or get current from Local storage
        this.props.dispatch(identify());
        // use units for localization. Back to only inches for current version.
        this.props.dispatch(setUnitDatabase({ unit: 'inches' }))

        // save to store link to Ridesizer app
        const link = getExternalLink();
        this.props.dispatch(setLinkDatabase({ link }));

        // select default bike to show on first app load
        const bike = searchService.defaultBike();
        bike.color = bike.colors[0];
        this.props.dispatch(setColorDatabase(undefined, bike));  
        this.props.dispatch(setBike({ bike }));

        // Set url parameters - parent website and others
        this.props.dispatch(setPageParams());
   
    }

    render() {
        return (
            <div className="container">
                <div className="ridesizer">              
                    <div className="bike-block">
                        <Rotate360 />
                    </div>
                    <div className="controls">
                        <h1>Ridesizer</h1>
                        <Range />
                        <div className="date-and-color">
                            <Datepicker />
                            <Colors />  
                        </div>  
                        <FormEmail />    
                        <p className="patent">RideSizer is currently patent pending</p>          
                    </div>
                </div>
                <footer>
                    <div />
                    <PDFGenerator />
                </footer>
            </div>
        )
    }
}

// REDUX STATES
const mapStateToProps = (state) => {
    return {
        email: state.user.email
    }
};

export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/components/App.js